// Order matters

// widgets
require('./widgets/googleanalytics');
require('./widgets/checkout_root');

// components

// handlers
require('od-modules/frontend-shell/base-integration');
require('./modules/frontend-shell/desktop.flights-checkout');
